let Categories = [
    {
        ID: 1,
        Name: "Muške Dioptrijske",
    },
    {
        ID: 2,
        Name: "Ženske Dioptrijske",
    },
    {
        ID: 3,
        Name: "Dječije Dioptrijske",
    },
    {
        ID: 4,
        Name: "Muške Sunčane",
    },
    {
        ID: 5,
        Name: "Ženske Sunčane",
    },
    {
        ID: 6,
        Name: "Sočiva",
    },
];

export default Categories;
